import Vue from 'vue'
import Router from 'vue-router'
import HomeList from '../components/home-list/HomeList';
import PendingApps from '../components/pending-apps/PendingApps';
import ActivePrograms from '../components/active-programs/ActivePrograms';
import ClosedPrograms from '../components/closed-programs/ClosedPrograms';
import Resource from '../components/resources/Resource';

Vue.use(Router)

var originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(function(err) { return err })
}

var router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: HomeList
    }, {
      path: '/pendingApps',
      name: 'My Apps',
      component: PendingApps
    }, {
      path: '/pendingApps/:recordId',
      name: 'My Apps',
      component: PendingApps
    }, {
      path: '/activePrograms',
      name: 'Active Programs',
      component: ActivePrograms
    }, {
      path: '/activePrograms/:recordId',
      name: 'Active Programs',
      component: ActivePrograms
    }, {
      path: '/closedPrograms',
      name: 'Closed Programs',
      component: ClosedPrograms
    }, {
      path: '/closedPrograms/:recordId',
      name: 'Closed Programs',
      component: ClosedPrograms
    }, {
      path: '/resources',
      name: 'Resources',
      component: Resource
    }, {
      path: '/resources/:recordId',
      name: 'Resources',
      component: Resource
    }
  ]
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js